import { useCallback } from 'react';
import { PRODUCT_NAMES, useRevenueCatPaywall } from './useRevenueCatPaywall';

interface UseShopPaywallOptions {
    onLoadingChange: (productName: string, isLoading: boolean) => void;
    userId: string | undefined;
    userBisk: number | undefined;
    username: string | undefined;
}

/**
 * Specialized hook for Shop component that provides individual paywall handlers
 * for each product with integrated loading state management
 */
export const useShopPaywall = (options: UseShopPaywallOptions) => {
    const { onLoadingChange, userId, userBisk, username } = options;

    // Create paywall handler for Tow Rope Pass
    const {
        presentPaywall: presentTowRopePaywall,
    } = useRevenueCatPaywall({
        entitlementIdentifier: 'pro',
        redirectToShop: false,
        trackAnalytics: true,
        productName: PRODUCT_NAMES.TOW_ROPE_PASS,
        onLoadingChange,
        userId,
        userBisk,
        username
    });

    // Generic handler that can be called with any product name
    const handleProductCheckout = useCallback(async () => {
        return await presentTowRopePaywall()
    }, [presentTowRopePaywall]);

    return {
        // Generic handler
        handleProductCheckout,
        // Individual handlers
        presentTowRopePaywall,
        // Product constants for convenience
        PRODUCTS: PRODUCT_NAMES
    };
};
